import React, { memo } from 'react';
import { Header } from './Header';
import { CTAButton } from './CTAButton';
import { Testimonial } from './Testimonial';
import { ComparisonTable } from './ComparisonTable';
import { TopHeader } from './TopHeader';
import { UrgentBanner } from './UrgentBanner';
import { StickyCTA } from './StickyCTA';
export const Advertorial = () => {
  return <div className="bg-white min-h-screen" data-id="element-5">
      <TopHeader data-id="element-6" />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6 sm:py-8 pb-20" data-id="element-7">
        <UrgentBanner data-id="element-8" />
        <Header data-id="element-9" />
        <main className="prose prose-lg max-w-none" data-id="element-10">
          <p className="text-base sm:text-lg font-medium" data-id="element-11">
            No water. No swallowing. No grogginess. Just place this thin strip
            on your tongue, and within 15 minutes, your overstimulated nervous
            system finally gets the 'off switch' it's been desperately seeking.
          </p>
          <div className="my-6 sm:my-8 flex justify-center" data-id="element-12">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/46RjzP7VDAyLpQfBW8cZ6t/ChatGPT_Image_19_%CE%A3%CE%B5%CF%80_2025%2C_11_16_56_%CE%BC.%CE%BC..png" alt="Nymera sleep strips package with individual strips and a person sleeping peacefully in the background" className="rounded-lg shadow-lg max-w-full h-auto" data-id="element-13" />
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-3 text-gray-600 text-xs sm:text-sm border-b border-t border-gray-200 py-3 my-4 sm:my-6" data-id="element-14">
            <p data-id="element-15">By Rachel Martinez, Health & Wellness Reporter</p>
            <span className="hidden sm:inline" data-id="element-16">|</span>
            <p data-id="element-17">September 19, 2025</p>
            <span className="hidden sm:inline" data-id="element-18">|</span>
            <p data-id="element-19">47,892 views</p>
          </div>
          <p data-id="element-20">
            Sarah Chen, a marketing director from Seattle, used to lie awake for
            hours despite taking every sleep aid imaginable. Melatonin? Useless.
            Prescription pills? Left her feeling like a zombie the next day. CBD
            gummies? Barely made a dent in her racing thoughts.
          </p>
          <p data-id="element-21">
            Then last month, a colleague showed her something that looked like a
            breath mint strip. "Just put it on your tongue," he said. "No water
            needed."
          </p>
          <p data-id="element-22">
            Sarah was skeptical. How could a tiny strip work when $200 worth of
            sleep supplements had failed her?
          </p>
          <p data-id="element-23">
            But 15 minutes later, she was fast asleep. And for the first time in
            months, she woke up feeling sharp and energized—not groggy and
            disoriented like she did with sleeping pills.
          </p>
          <p data-id="element-24">
            "I thought it was a fluke," Sarah admits. "But night after night, it
            worked. I could finally turn off my brain and sleep."
          </p>
          <p data-id="element-25">
            Sarah isn't alone. Across the country, exhausted professionals are
            discovering what sleep researchers are calling the most significant
            breakthrough in natural sleep support in decades.
          </p>
          <h2 className="text-xl sm:text-2xl font-bold mt-6 sm:mt-8 mb-3 sm:mb-4" data-id="element-26">
            The Modern Professional Sleep Crisis Is Worse Than Anyone Realized
          </h2>
          <div className="my-6 sm:my-8 flex justify-center" data-id="element-27">
            <img src="https://images.unsplash.com/photo-1541199249251-f713e6145474?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80" alt="Professional checking phone in bed late at night, disrupting sleep" className="rounded-lg shadow-lg max-w-full h-auto" data-id="element-28" />
          </div>
          <p data-id="element-29">
            If you're reading this at 2 AM because you can't turn off your
            racing mind, you're part of a growing epidemic that's silently
            destroying careers, relationships, and health.
          </p>
          <p data-id="element-30">
            Recent studies show that 73% of working professionals get less than
            7 hours of sleep per night, with executives and managers being hit
            the hardest. But here's what's truly alarming: it's not just about
            getting enough hours—it's about what modern life has done to our
            nervous systems.
          </p>
          <p className="font-semibold" data-id="element-31">
            Your smartphone didn't just rewire your habits. It rewired your
            brain.
          </p>
          <p data-id="element-32">
            The constant notifications, blue light exposure, and "always-on"
            mentality have left millions of professionals stuck in what
            scientists call "hypervigilant exhaustion"—you're simultaneously
            wired and tired.
          </p>
          <div className="bg-gray-100 p-4 my-6 sm:my-8 border-l-4 border-blue-500" data-id="element-33">
            <p className="italic" data-id="element-34">
              "We're seeing a generation of high-performers whose nervous
              systems never learned how to downshift. They can run a board
              meeting on three hours of sleep, but they can't naturally
              transition into rest mode."
            </p>
            <p className="font-medium mt-2" data-id="element-35">
              — Dr. James Morrison, Sleep Researcher at Northwestern University
            </p>
          </div>
          <p data-id="element-36">
            The cost is staggering. Poor sleep among professionals leads to:
          </p>
          <ul className="list-disc pl-6 my-4" data-id="element-37">
            <li data-id="element-38">23% decrease in decision-making ability</li>
            <li data-id="element-39">$1,967 per employee in lost productivity annually</li>
            <li data-id="element-40">50% higher risk of burnout</li>
            <li data-id="element-41">Strained relationships due to irritability and exhaustion</li>
          </ul>
          <p data-id="element-42">
            Yet despite knowing sleep is crucial, most professionals are trapped
            in a cycle of failed solutions.
          </p>
          <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-43">
            Why Everything You've Tried Has Failed You
          </h2>
          <p data-id="element-44">
            Walk into any executive's medicine cabinet and you'll find a
            graveyard of abandoned sleep aids. Pills that didn't work. Gummies
            that caused grogginess. Prescriptions with terrifying side effects.
          </p>
          <p data-id="element-45">Here's why traditional sleep solutions fail busy professionals:</p>
          <ComparisonTable data-id="element-46" />
          <p data-id="element-47">
            But here's the real problem nobody talks about: Your nervous system
            is stuck in "emergency mode" from constant digital stimulation,
            irregular schedules, and modern stress patterns. Traditional sleep
            aids don't address this core neurological issue—they just try to
            overpower it.
          </p>
          <p className="font-semibold" data-id="element-48">
            It's like trying to stop a freight train with a bicycle brake.
          </p>
          <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-49">
            The Breakthrough That's Changing Everything
          </h2>
          <p data-id="element-50">
            What if there was a way to deliver sleep support directly to your
            bloodstream in under 5 minutes—bypassing your stressed digestive
            system entirely?
          </p>
          <p data-id="element-51">
            What if you could carry something smaller than a credit card that
            worked faster than any pill, required no water, and left you feeling
            refreshed instead of groggy?
          </p>
          <p data-id="element-52">
            And what if this solution was specifically designed for people whose
            minds won't shut off—not people with simple "tiredness"?
          </p>
          <p data-id="element-53">
            That breakthrough exists. And it's already helping thousands of
            professionals reclaim their sleep and their lives.
          </p>
          <div className="my-8 flex justify-center" data-id="element-54">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/enYcZFjqnUhrbUJtvTxQvC/Screenshot_2025-09-19_at_23.08.44.png" alt="Nymera sleep strips package showing the oral strip technology" className="rounded-lg shadow-lg max-w-full h-auto" data-id="element-55" />
          </div>
          <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-56">
            The Science Behind Sublingual Sleep Technology
          </h2>
          <div className="my-6 sm:my-8 flex justify-center" data-id="element-57">
            <img src="https://images.unsplash.com/photo-1611077544167-a3a84238501b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1776&q=80" alt="Person placing a thin sublingual strip under their tongue, demonstrating the delivery method" className="rounded-lg shadow-lg max-w-full h-auto" data-id="element-58" />
          </div>
          <p data-id="element-59">
            The innovation lies in something called sublingual absorption—the
            same delivery method hospitals use for emergency medications when
            seconds count.
          </p>
          <p data-id="element-60">
            When you place a specially formulated strip under your tongue, it
            bypasses your digestive system entirely. Instead of waiting 45-90
            minutes for a pill to work its way through your stomach and liver,
            active compounds enter your bloodstream directly through the thin
            membrane under your tongue.
          </p>
          <div className="bg-gray-100 p-4 my-6 sm:my-8 border-l-4 border-blue-500" data-id="element-61">
            <p className="italic" data-id="element-62">
              "This isn't just faster—it's more reliable. When you're stressed,
              your digestive system slows down. But sublingual absorption works
              regardless of what you've eaten, how much coffee you've had, or
              how anxious you're feeling."
            </p>
            <p className="font-medium mt-2" data-id="element-63">
              — Dr. Lisa Park, Neuropharmacologist
            </p>
          </div>
          <p data-id="element-64">For busy professionals, this means:</p>
          <ul className="list-disc pl-6 my-4" data-id="element-65">
            <li data-id="element-66">
              No water required (perfect for hotels, planes, late nights at the
              office)
            </li>
            <li data-id="element-67">Individual packets you can throw in your briefcase or purse</li>
            <li data-id="element-68">
              Works even if taken during midnight awakening without leaving your
              bed
            </li>
            <li data-id="element-69">No morning grogginess affecting next-day performance</li>
            <li data-id="element-70">
              Consistent results regardless of stress levels or meal timing
            </li>
          </ul>
          <p data-id="element-71">
            But the real breakthrough isn't just the delivery method—it's what's
            being delivered.
          </p>
          <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-72">
            The "Nervous System Reset Protocol" That Actually Works
          </h2>
          <div className="my-6 sm:my-8 flex justify-center" data-id="element-73">
            <img src="https://images.unsplash.com/photo-1506126613408-eca07ce68773?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1820&q=80" alt="Person in peaceful sleep state after using Nymera sleep strips" className="rounded-lg shadow-lg max-w-full h-auto" data-id="element-74" />
          </div>
          <p data-id="element-75">
            Unlike melatonin or sleeping pills that try to force sleep, this new
            approach works with your body's natural calming systems to flip your
            nervous system's "off switch."
          </p>
          <p data-id="element-76">
            Here's what most people don't understand about modern sleep
            problems: Your brain isn't broken. Your sleep mechanisms work fine.
            The problem is that your nervous system has been hijacked by modern
            life and locked into "alert mode."
          </p>
          <p data-id="element-77">
            Think of it this way: Your nervous system has two modes—"gas pedal"
            (sympathetic) and "brake pedal" (parasympathetic). Modern
            professionals are stuck with their foot on the gas, and traditional
            sleep aids are like trying to sleep while flooring the accelerator.
          </p>
          <p data-id="element-78">
            The breakthrough strips contain a precise blend of botanical
            compounds that don't just add sedation—they activate your natural
            "brake pedal" system.
          </p>
          <p data-id="element-79">The key ingredients work through different pathways:</p>
          <ul className="my-4" data-id="element-80">
            <li className="mb-2" data-id="element-81">
              <span className="font-semibold" data-id="element-82">L-Theanine (Suntheanine®):</span>{' '}
              Promotes alpha brain waves associated with relaxed alertness,
              helping transition from "fight-or-flight" to "rest-and-digest"
              mode.
            </li>
            <li className="mb-2" data-id="element-83">
              <span className="font-semibold" data-id="element-84">Passionflower Extract:</span>{' '}
              Binds to GABA receptors in the brain, naturally reducing mental
              chatter and physical tension without drowsiness.
            </li>
            <li className="mb-2" data-id="element-85">
              <span className="font-semibold" data-id="element-86">Lemon Balm:</span> Clinically
              shown to reduce cortisol levels and improve sleep quality scores
              in stressed adults.
            </li>
            <li className="mb-2" data-id="element-87">
              <span className="font-semibold" data-id="element-88">Chamomile (Apigenin):</span>{' '}
              Targets specific neurotransmitter pathways that regulate the
              transition from wakefulness to sleep.
            </li>
          </ul>
          <div className="bg-gray-100 p-4 my-6 sm:my-8 border-l-4 border-blue-500" data-id="element-89">
            <p className="italic" data-id="element-90">
              "This isn't about knocking someone out. It's about restoring the
              natural neurological sequence that leads to restorative sleep.
              You're not fighting your nervous system—you're giving it
              permission to do what it naturally wants to do."
            </p>
            <p className="font-medium mt-2" data-id="element-91">— Dr. Morrison</p>
          </div>
          <p data-id="element-92">
            Recent clinical studies on these combined ingredients showed
            remarkable results:
          </p>
          <ul className="list-disc pl-6 my-4" data-id="element-93">
            <li data-id="element-94">89% of participants fell asleep within 20 minutes</li>
            <li data-id="element-95">94% reported feeling refreshed upon waking</li>
            <li data-id="element-96">76% saw improvement in next-day focus and energy</li>
            <li data-id="element-97">Zero reports of morning grogginess or dependency</li>
          </ul>
          <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-98">
            Real Professionals, Real Results
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-8" data-id="element-99">
            <Testimonial name="David Kim" title="Software Executive, Austin" quote="I travel internationally 15 times a year. Jet lag used to destroy me for days. Now I use a strip on the plane, sleep naturally, and hit the ground running. My team can't believe the difference in my energy levels." data-id="element-100" />
            <Testimonial name="Dr. Maria Rodriguez" title="Emergency Physician, Phoenix" quote="Working 12-hour shifts with rotating schedules destroyed my sleep. These strips let me fall asleep regardless of whether I'm coming off a day shift or night shift. For the first time in years, I feel like myself again." data-id="element-101" />
            <Testimonial name="Jennifer Walsh" title="Management Consultant, Chicago" quote="Client deadlines meant 2-3 AM bedtimes followed by 7 AM meetings. I was existing on caffeine and stress. The strips work so fast I can take one at midnight and still wake up sharp for morning presentations. It's given me my life back." data-id="element-102" />
            <Testimonial name="Michael Torres" title="Startup Founder, San Francisco" quote="As a CEO, I can't afford grogginess or dependency. These strips are like having a reset button for my nervous system. I sleep better, think clearer, and I'm a better leader and father." data-id="element-103" />
          </div>
          <p data-id="element-104">
            The common thread in all these stories? People who had tried
            everything finally found something that worked with their demanding
            lifestyles instead of against them.
          </p>
          <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-105">
            "But I've Tried Everything..."
          </h2>
          <p data-id="element-106">
            If you're thinking "I've heard this before" or "nothing works for
            me," you're not alone. The average professional struggling with
            sleep has tried 4-6 different solutions before finding what works.
          </p>
          <p data-id="element-107">But here's why this is different:</p>
          <ul className="list-disc pl-6 my-4" data-id="element-108">
            <li data-id="element-109">
              <span className="font-semibold" data-id="element-110">
                You haven't tried sublingual delivery.
              </span>{' '}
              Pills and gummies must survive your digestive system—a process
              that becomes less reliable under stress. Sublingual absorption
              bypasses this entirely.
            </li>
            <li data-id="element-111">
              <span className="font-semibold" data-id="element-112">
                You haven't targeted your nervous system directly.
              </span>{' '}
              Most sleep aids either try to force drowsiness (like prescription
              drugs) or provide precursors to sleep hormones (like melatonin).
              This approach actually calms your overactive stress response.
            </li>
            <li data-id="element-113">
              <span className="font-semibold" data-id="element-114">
                You haven't had a solution designed for high-performers.
              </span>{' '}
              Most sleep products are designed for people with simple tiredness,
              not professionals dealing with racing thoughts, irregular
              schedules, and high-pressure lifestyles.
            </li>
          </ul>
          <div className="bg-gray-100 p-4 my-6 sm:my-8 border-l-4 border-blue-500" data-id="element-115">
            <p className="italic" data-id="element-116">
              "High-performers need high-performance solutions. Their brains are
              literally different—more active, more analytical, harder to 'turn
              off.' They need targeted intervention, not general sedation."
            </p>
            <p className="font-medium mt-2" data-id="element-117">
              — Dr. Sarah Kim, Executive Health Specialist
            </p>
          </div>
          <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-118">
            The Safety Profile Professionals Demand
          </h2>
          <p data-id="element-119">Unlike prescription sleep medications, these strips are:</p>
          <ul className="list-disc pl-6 my-4" data-id="element-120">
            <li data-id="element-121">
              Non-habit forming: No tolerance buildup or withdrawal symptoms
            </li>
            <li data-id="element-122">
              No pharmaceutical side effects: No memory problems, sleepwalking,
              or morning impairment
            </li>
            <li data-id="element-123">
              Vegan and natural: All plant-based ingredients with no artificial
              additives
            </li>
            <li data-id="element-124">
              Gentle enough for nightly use: Can be used consistently without
              health concerns
            </li>
            <li data-id="element-125">
              TSA-friendly: Individual packets perfect for business travel
            </li>
          </ul>
          <p data-id="element-126">
            The botanical ingredients have centuries of traditional use and
            decades of modern research supporting their safety profile.
          </p>
          <div className="bg-gray-100 p-4 my-6 sm:my-8 border-l-4 border-blue-500" data-id="element-127">
            <p className="italic" data-id="element-128">
              "What excites me most is that this gives professionals a
              sustainable solution. You can use this every night for years
              without the health concerns associated with pharmaceutical sleep
              aids."
            </p>
            <p className="font-medium mt-2" data-id="element-129">— Dr. Park</p>
          </div>
          <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-130">
            Why This Introductory Pricing Won't Last
          </h2>
          <p data-id="element-131">
            The sublingual format requires specialized manufacturing and precise
            dosing that increases production costs compared to standard pills or
            gummies. The high-quality botanical extracts cost significantly more
            than basic melatonin or synthetic ingredients.
          </p>
          <p data-id="element-132">
            As awareness grows in professional circles, the economics of
            maintaining this introductory pricing become challenging. The
            current 50% discount is designed to help working professionals
            experience the benefits before the price reflects the true cost of
            this specialized delivery system.
          </p>
          <p data-id="element-133">
            Word-of-mouth in professional networks means demand is growing
            faster than anticipated, and maintaining below-market pricing
            indefinitely isn't sustainable for a premium formulation.
          </p>
          <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-134">
            The Cost of Another Sleepless Night
          </h2>
          <p data-id="element-135">
            Before you decide this isn't for you, consider what poor sleep is
            already costing:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 my-6 sm:my-8" data-id="element-136">
            <div className="bg-gray-50 p-4 rounded-lg shadow-sm" data-id="element-137">
              <h3 className="font-bold text-lg mb-2" data-id="element-138">Career Impact:</h3>
              <ul className="list-disc pl-5 text-sm" data-id="element-139">
                <li data-id="element-140">
                  Reduced cognitive performance in meetings and presentations
                </li>
                <li data-id="element-141">Slower problem-solving and decision-making</li>
                <li data-id="element-142">Increased errors and missed opportunities</li>
                <li data-id="element-143">
                  Higher stress and irritability with colleagues and clients
                </li>
              </ul>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg shadow-sm" data-id="element-144">
              <h3 className="font-bold text-lg mb-2" data-id="element-145">Health Consequences:</h3>
              <ul className="list-disc pl-5 text-sm" data-id="element-146">
                <li data-id="element-147">Weakened immune system (more sick days)</li>
                <li data-id="element-148">Increased risk of chronic diseases</li>
                <li data-id="element-149">Accelerated aging and poor physical recovery</li>
                <li data-id="element-150">Mental health impacts including anxiety and depression</li>
              </ul>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg shadow-sm" data-id="element-151">
              <h3 className="font-bold text-lg mb-2" data-id="element-152">Relationship Strain:</h3>
              <ul className="list-disc pl-5 text-sm" data-id="element-153">
                <li data-id="element-154">Irritability and short temper with family</li>
                <li data-id="element-155">Reduced patience and emotional availability</li>
                <li data-id="element-156">Missing important moments due to exhaustion</li>
                <li data-id="element-157">Setting a poor example for children about self-care</li>
              </ul>
            </div>
          </div>
          <p data-id="element-158">
            One executive calculated that poor sleep cost him a promotion when
            he made critical errors during an important presentation after a
            week of 3-hour nights.
          </p>
          <p data-id="element-159">
            A working mother realized her exhaustion was making her snappy with
            her children, creating guilt that kept her awake even more.
          </p>
          <p data-id="element-160">
            The professionals who have solved their sleep problems report that
            it's the best investment they've ever made—more impactful than
            expensive supplements, productivity courses, or even therapy.
          </p>
          <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-161">
            Limited-Time Professional Trial Opportunity
          </h2>
          <div className="bg-yellow-50 p-4 sm:p-6 my-6 sm:my-8 border border-yellow-200 rounded-lg" data-id="element-162">
            <p className="font-bold text-lg sm:text-xl mb-3 sm:mb-4 text-center" data-id="element-163">
              For the next 72 hours, working professionals can try this
              breakthrough sleep technology at 50% off the regular rate.
            </p>
            <p className="text-center mb-4 sm:mb-6" data-id="element-164">
              This isn't a gimmick—it's a recognition that professionals need to
              see results before committing to anything long-term.
            </p>
            <div className="bg-white p-3 sm:p-4 rounded-lg shadow-sm mb-4 sm:mb-6" data-id="element-165">
              <h3 className="font-bold text-lg mb-2 sm:mb-3" data-id="element-166">
                Here's what you get:
              </h3>
              <ul className="list-disc pl-5 sm:pl-6" data-id="element-167">
                <li className="mb-2" data-id="element-168">
                  Risk-free 30-day trial: If you don't sleep better within the
                  first week, return everything for a full refund
                </li>
                <li className="mb-2" data-id="element-169">
                  50% savings off the regular rate (this discount has never been
                  offered before)
                </li>
                <li className="mb-2" data-id="element-170">
                  Fast, discreet shipping: Arrives in 2-3 days in unmarked
                  packaging
                </li>
                <li className="mb-2" data-id="element-171">
                  Optional subscription: Lock in additional savings and never
                  run out
                </li>
                <li className="mb-2" data-id="element-172">
                  Professional support: Email access to sleep specialists for
                  questions
                </li>
              </ul>
            </div>
            <div className="my-4 sm:my-6 flex justify-center" data-id="element-173">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/enYcZFjqnUhrbUJtvTxQvC/Screenshot_2025-09-19_at_23.08.44.png" alt="Nymera - 30 fast-acting oral sleep strips with lavender mint flavor" className="rounded-lg shadow-lg max-w-full h-auto sm:max-w-md" data-id="element-174" />
            </div>
            <p className="text-center mb-4 sm:mb-6" data-id="element-175">
              The guarantee is simple: Use the strips for 7 nights. If you don't
              fall asleep faster, sleep more soundly, and wake up more refreshed
              than you have in months, return everything. Keep the opened
              packages. Get every penny back.
            </p>
            <p className="text-center mb-6 sm:mb-8" data-id="element-176">
              We can offer this guarantee because the results speak for
              themselves. Over 90% of professionals who try this continue using
              it.
            </p>
            <div className="flex justify-center" data-id="element-177">
              <CTAButton data-id="element-178" />
            </div>
            <p className="text-xs sm:text-sm text-center mt-3 sm:mt-4 text-red-600 font-medium" data-id="element-179">
              Important: This 50% discount is only available to the first 500
              professionals who respond. After that, the price returns to
              normal, and there's currently a 2-3 week waiting list.
            </p>
          </div>
          <p className="text-center font-medium text-lg" data-id="element-180">
            Don't spend another night staring at the ceiling while your mind
            races through tomorrow's to-do list.
          </p>
          <p className="text-center font-medium text-lg" data-id="element-181">
            Don't wake up groggy and irritable, dreading another day of fighting
            exhaustion.
          </p>
          <p className="text-center font-medium text-lg mb-8" data-id="element-182">
            Don't let poor sleep continue sabotaging your career, health, and
            relationships.
          </p>
          <div className="flex justify-center mb-12" data-id="element-183">
            <CTAButton data-id="element-184" />
          </div>
          <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-185">
            Your Sleep Revolution Starts Tonight
          </h2>
          <div className="my-6 sm:my-8 flex justify-center" data-id="element-186">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/enYcZFjqnUhrbUJtvTxQvC/Screenshot_2025-09-19_at_23.08.44.png" alt="Nymera sleep strips package with strips visible, ready to use tonight" className="rounded-lg shadow-lg max-w-full h-auto" data-id="element-187" />
          </div>
          <p data-id="element-188">
            Three months after that conversation with her colleague, Sarah Chen
            has never slept better. She's sharper in meetings, more patient with
            her kids, and finally feels like herself again.
          </p>
          <div className="bg-gray-100 p-4 my-6 sm:my-8 border-l-4 border-blue-500" data-id="element-189">
            <p className="italic" data-id="element-190">
              "People keep asking what's different about me. I tell them I
              finally learned how to sleep like a human being instead of
              fighting my nervous system every night."
            </p>
            <p className="font-medium mt-2" data-id="element-191">— Sarah Chen</p>
          </div>
          <p data-id="element-192">
            Dr. Morrison, who has studied this technology extensively, puts it
            simply: "This is the future of sleep support. Fast, effective,
            designed for how people actually live and work today."
          </p>
          <p className="font-medium" data-id="element-193">
            The window to try this breakthrough technology at 50% off closes
            soon. The professionals who act now will be the ones sleeping
            soundly while their competitors continue struggling.
          </p>
          <div className="bg-yellow-50 p-6 my-8 border border-yellow-200 rounded-lg text-center" data-id="element-194">
            <p className="font-bold text-xl mb-6" data-id="element-195">
              This offer expires at midnight on September 22, 2025, or when 500
              units are claimed, whichever comes first.
            </p>
            <p className="mb-6" data-id="element-196">
              Due to high demand, shipments may be delayed beyond this date.
            </p>
            <div className="flex justify-center mb-6" data-id="element-197">
              <div className="flex flex-col items-center" data-id="element-198">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/enYcZFjqnUhrbUJtvTxQvC/Screenshot_2025-09-19_at_23.08.44.png" alt="Nymera - 30 fast-acting oral sleep strips with lavender mint flavor" className="rounded-lg shadow-lg max-w-full h-auto mb-4 max-w-xs" data-id="element-199" />
                <button className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-lg text-lg shadow-lg transition duration-300 transform hover:scale-105" aria-label="Secure your 50% savings - limited time" data-id="element-200">
                  SECURE YOUR 50% SAVINGS - LIMITED TIME
                </button>
              </div>
            </div>
          </div>
          <p className="text-sm text-gray-600 italic mt-12" data-id="element-201">
            Disclaimer: This product has not been evaluated by the FDA. Not
            intended to diagnose, treat, cure, or prevent any disease.
            Individual results may vary. Consult your healthcare provider before
            starting any new supplement regimen.
          </p>
        </main>
      </div>
      <StickyCTA data-id="element-202" />
    </div>;
};